import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27d6436a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "pb" }
const _hoisted_4 = { class: "pb" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", { class: "pb" }, "Controls:"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", { class: "pb" }, "Arrow keys to move"),
      /*#__PURE__*/_createElementVNode("li", { class: "pb" }, [
        /*#__PURE__*/_createTextVNode(" To rotate: "),
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, "W/S for Y axis"),
          /*#__PURE__*/_createElementVNode("li", null, "A/D for X axis"),
          /*#__PURE__*/_createElementVNode("li", null, "Q/E for Z axis")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, "I/O to scale")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, "Choose a file: " + _toDisplayString(_ctx.file), 1),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "file",
              value: "cube.obj",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.file) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.file]
            ]),
            _createTextVNode(" Cube ")
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "file",
              value: "lightedCube.obj",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.file) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.file]
            ]),
            _createTextVNode(" Lighted cube ")
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "file",
              value: "pyramid.obj",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.file) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.file]
            ]),
            _createTextVNode(" Pyramid ")
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "file",
              value: "teapot.obj",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.file) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.file]
            ]),
            _createTextVNode(" Teapot ")
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", null, [
          _createTextVNode(" Or upload your own: "),
          _hoisted_5,
          _createElementVNode("input", {
            type: "file",
            id: "obj-file",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('upload', $event)))
          }, null, 32)
        ])
      ])
    ]),
    _hoisted_6
  ]))
}